import styled from 'styled-components/macro';

export const Data = styled.div`
  display: inline-block;
  cursor: pointer;

  img {
    height: ${(props) => (props.lockSize ? props.lockSize : '15px')};
    width: ${(props) => (props.lockSize ? props.lockSize : '15px')};
    display: inline-block;
    margin-left: 5px;
  }
`;

export const DataLock = styled.span`
  ${(props) =>
    props.fontStyles ||
    `
    font-family: 'Lato';
    font-weight: 700;
    font-size: 12px;
  `}
  display: inline-block;
`;
